import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { PocApp } from "./poc/PocApp";
import { StudyProgramPage } from "./StudyProgramPage";
import {
  readSessionCodeFromUrl,
  readStudyProgramCodeFromUrl,
} from "./session/token";
import "./styles/global.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root bulunamadı");
}

/**
 * Rota:
 *   /calisma-programi/{kod} -> Calisma Programi (stub, runner bitiminden gelir)
 *   /s/{kod}                -> uretim App'i (session player)
 *   digerleri               -> YEREL gelistirmede POC; uretim build'inde App.
 */
const studyProgramCode = readStudyProgramCodeFromUrl(window.location.pathname);
const isSession = readSessionCodeFromUrl(window.location.pathname) !== null;

createRoot(container).render(
  <StrictMode>
    {studyProgramCode !== null ? (
      <StudyProgramPage code={studyProgramCode} />
    ) : isSession || !import.meta.env.DEV ? (
      <App />
    ) : (
      <PocApp />
    )}
  </StrictMode>,
);
